import fileIconTemplate from './file-icon.tpl.html';
import './file-icon.less';
import {
  getFileIcon,
  getFileLanguage,
} from '../../utils/file-utils/file-utils';

// List of all icons we have in the system
// There's no easy way to extract the list of `lang-*` icons, so this is manually duplicated here
// Note: Leave the leading and trailing pipes (|) to avoid substring matching
const LANG_ICONS = `|txt|angular|c|clojure|coffeescript|cpp|crystal|csharp|css|dart|django|elasticsearch|elixir|erlang|fsharp|go|groovy|haskell|html|java|javascript|jquery|kotlin|lua|markdown|mongo|mysql|net|nodejs|objc|ocaml|php|postgresql|python|r|rails|react|redis|ruby|rust|scala|shell|solidity|sql|sqlite|swift|typescript|`;

// Provides a way to map known extensions into something shorter or neater
const EXT_MAP = {
  less: '{L}',
  scss: '{S}',
  sass: '{S}',
  svg: '🏞',
  xml: '</>',
};

export const fileIconComponentModule = angular
  .module('Q.components.file-icon', [])

  .component('fileIcon', {
    bindings: {
      file: '<',
      expanded: '<',
    },
    controller: 'FileIconCtrl',
    template: fileIconTemplate,
  })

  .controller('FileIconCtrl', function FileIconCtrl($element, $scope) {
    const ctrl = this;

    ctrl.$onInit = () => {
      const file = ctrl.file;
      ctrl.extension = '';
      if (ctrl.icon) {
        $element.removeClass(ctrl.icon);
      }
      if (!file || (file.path === undefined && !file.icon)) {
        $element.addClass('no-icon');
        return;
      }
      $element.removeClass('no-icon');

      ctrl.icon = getFileIcon(file);
      $element.addClass(ctrl.icon);

      const custom = angular.isString(file.icon);
      $element.toggleClass('custom', custom);

      if (file && !file.directory && !custom) {
        let ext = getFileLanguage(file);
        ext = EXT_MAP[ext] || ext;
        if (ext && ext.length < 4 && !LANG_ICONS.includes(`|${ext}|`)) {
          ctrl.extension = ext;
        }
      }
      $element.toggleClass('extension', !!ctrl.extension);

      $element.toggleClass('is-dir', !!file.directory);
      $element.toggleClass('expanded', !!ctrl.expanded);
      $element.toggleClass('inv', !!file.reference);
      $element.toggleClass('deleted', !!file.$deleted);
    };
    $scope.$watch(
      () =>
        `${ctrl.expanded}${ctrl.file ? ctrl.file.path + ctrl.file.icon + ctrl.file.$deleted : ''}`,
      () => {
        ctrl.$onInit();
      },
    );
  });
